import BrandSubscriptionServiceCallState from '../store/schema/BrandSubscriptionServiceCallState';
import { BlockedSendersMap } from '../store/schema/BrandsSubscriptionsStore';
import datapoints from '../datapoints';
import { GetBrandsSubscriptionsServiceResponse } from 'owa-brands-subscription';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

const setServiceCallState = action(
    'SET_SERVICE_CALL_STATE',
    (state: BrandSubscriptionServiceCallState) => ({
        state: state,
    })
);

const loadBrandsSubscriptions = action('LOAD_BRANDS_SUBSCRIPTIONS', () =>
    addDatapointConfig(datapoints.LoadBrandsSubscriptions)
);

const updateBrandsSubscriptions = action(
    'UPDATE_BRANDS_SUBSCRIPTIONS',
    (response: GetBrandsSubscriptionsServiceResponse, blockedSendersMap: BlockedSendersMap) => ({
        response: response,
        blockedSendersMap: blockedSendersMap,
    })
);

const onUnsubscribeFromBrand = action('ON_UNSUBSCRIBE_FROM_BRAND', (smtpIdentifier: string) => ({
    smtpIdentifier: smtpIdentifier,
}));

const blockSender = action(
    'BLOCK_SENDER',
    (displayName: string, emailAddress: string, isUnsubscribed: boolean) =>
        addDatapointConfig(datapoints.BlockSenderFromSubscriptions, {
            displayName: displayName,
            emailAddress: emailAddress,
            isUnsubscribed: isUnsubscribed,
        })
);

const removeSenderFromSubscriptionStore = action(
    'REMOVE_SENDER_FROM_SUBSCRIPTION_STORE',
    (emailAddress: string, isUnsubscribed: boolean) => ({
        emailAddress: emailAddress,
        isUnsubscribed: isUnsubscribed,
    })
);

export {
    setServiceCallState,
    loadBrandsSubscriptions,
    updateBrandsSubscriptions,
    onUnsubscribeFromBrand,
    blockSender,
    removeSenderFromSubscriptionStore,
};
